<template>
    <div 
        v-if="image" 
        id="atlas-grid" 
        class="atlas-grid"
    >
        <div v-if="image.header_content" 
            class="atlas-grid__table-header"
        >
            {{image.header_content}}
        </div>
        <div class="atlas-image__container">
            <img 
                :src="get_src(image)"
                alt="目前無法讀取"
                width="100%"
                height="100%"
                @click="show_detailed_picture(image)"
                @error="change_src(image)"
            >
        </div>
    </div>
</template>

<script>
	export default {
        name: 'atlas_grid',
        // 圖集功能以橫向為單位，每個橫向只能有一個小標題，側邊文字，下標
        props: {
            // 圖片陣列
            image: {
                type: Object,
                required: true,
            },
            // 要不要開啟點擊放大的功能，預設會放大
            enable_enlarge_func: {
                type: Boolean,
                default () {
                    return true
                }
            }
        },    

		methods: {
            show_detailed_picture(image) {
                const is_access_enlarge_image = this.enable_enlarge_func && !image.failed
                is_access_enlarge_image && this.$emit('open-image-dialog', image.src)
            },
            
            get_src(image) {
                if (image.failed) {
                    return image.alt_image;
                } 
                
                if (image.src == null) {
                    return this.white_src;
                } 
                
                return image.src
            },

            change_src(image) {
                image.failed = true; 
            },
        },
	}
</script>

<style lang="scss" scoped>
    .atlas-grid {
        margin: 8px 0;

        &__table-header {
            margin-bottom: 8px;
            padding: 6px;
            background: var(--white-bg);
            text-align: center;
            font-size: 14px;
            line-height: 20px;
            letter-spacing: 1px;
            font-weight: bold;
        }
    }
</style>